var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTape145367(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.49 73.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288.54 -421.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m578.81393,494.47484-289.05949-.01193-.21007-.02106-.1954-.06043-.17665-.09564-.15377-.12679-.12673-.15374-.09568-.17669-.06041-.19543-.02103-.21006 8.73455-8.83778-8.73382-8.83852 8.73452-8.83779-8.7338-8.83851 8.73453-8.83779-8.73376-8.83845 8.73449-8.83786-8.73376-8.83845 .02102-.2101 .06044-.19539 .09568-.17663 .12674-.15381 .15379-.12674 .17662-.09568 .19543-.06039 .21009-.02102 289.05948.01192 .21007.02106 .19542.06042 .17663.09565 .15377.12678 .12676.15377 .09565.17665 .0604.19543 .02103.21007-8.73454,8.83779 8.73382,8.8385-8.73454,8.83779 8.73381,8.83851-8.73454,8.83779 8.73381,8.83851-8.73454,8.83779 8.73382,8.83851-.02107.21007-.06041.1954-.09566.17666-.12677.15377-.15378.12676-.17666.09562-.19541.06042-.21008.02104z",
    fill: "#f2f2f2",
    fillOpacity: 0.73927,
    opacity: 0.5342,
    stroke: "#000",
    strokeWidth: 0.346
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape145367);
export default __webpack_public_path__ + "static/media/tape-145367.389926c37463f76b75944a3673acba07.svg";
export { ForwardRef as ReactComponent };